import { FC, memo, ReactNode } from "react";

import { Theme } from "apps/website/maps/Theme.map";
import {
  IExternalReview,
} from "apps/website/components/feature/Review/ExternalReview/ExternalReview";
import Grid from "apps/website/components/layout/Grid/Grid";
import Column from "apps/website/components/layout/Column/Column";
import Section from "apps/website/components/layout/Section/Section";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import Container from "apps/website/components/layout/Container/Container";
import { Layout } from "apps/website/components/feature/Review/Review.map";

import { getSectionSize } from "../../layout/Section/Section.utils";
import TrustPilotReviewWall from "../../feature/TrustPilotReviewWall/TrustPilotReviewWall";
import TextBody from "../../base/Text/TextBody/TextBody";
import TextTitle from "../../base/Text/TextTitle/TextTitle";

export interface ISectionTrustPilotReviewWall {
  reviews: IExternalReview[];
  footer: ReactNode;
  theme?: Theme;
  title?: string;
  layout?: Layout;
}

const SectionTrustPilotReviewWall: FC<ISectionTrustPilotReviewWall> = ({ title, footer, reviews, theme = "light-grey", layout }) => (
  <Section component="SectionTrustPilotReviewWall" theme={ theme } size={ getSectionSize(theme) }>
    <Container>
      { title && (
        <>
          <TextTitle tag="h2" size={2} align="center">
            { title }
          </TextTitle>
          <Spacer size="2xl" />
        </>
      ) }
      <TrustPilotReviewWall reviews={reviews} layout={layout} theme={theme} />
      <Spacer size="xl" />
      <div data-footer>
        <Grid>
          <Column>
            <TextBody
              tag="div"
              align="center"
              data-testid="SectionTrustPilotReviewWall-footerText"
            >{ footer }
            </TextBody>
          </Column>
        </Grid>
      </div>
    </Container>
  </Section>
);

export default memo(SectionTrustPilotReviewWall);
